import Row from "@/components/Table/Row";
import { RowRendererProps } from "@/components/Table/Table";
import tableStyles from "../../../../components/Table/Table.module.scss";
import { BomItem } from "../../useProducts";
import bomStyles from "./BomRow.module.scss";

export interface BomRowRendererProps<R = BomItem> extends RowRendererProps<R> {
  level?: number;
}

export default function BomRow({
  record,
  columns,
  rowKey,
  selectedKeys,
  onChangeCheckbox,
  rowLink,
  gridTemplateColumns,
  level,
}: BomRowRendererProps<BomItem>) {
  const children = record.children.sort((a, b) => (a.children.length > b.children.length ? 1 : -1));

  if (children.length > 0) {
    return (
      <div
        className={bomStyles["row-wrapper"]}
        style={{ paddingLeft: level || 0 ? "24px" : "0" }}
      >
        <div
          className={[tableStyles.row, bomStyles.part].join(" ")}
          key={Number(record[rowKey as keyof BomItem])}
        >
          <div className={bomStyles.wrapper}>
            <span className={bomStyles["bom-name"]}>{record.name}</span>
            <span>{record.quantity}x</span>
          </div>
        </div>
        {children.map((child) => (
          <BomRow
            key={Number(child[rowKey as keyof BomItem])}
            {...{
              record: child,
              columns,
              rowLink,
              rowKey,
              gridTemplateColumns,
              selectedKeys,
              onChangeCheckbox,
              level: (level || 0) + 1,
            }}
          />
        ))}
      </div>
    );
  }
  return (
    <Row
      {...{
        record,
        columns,
        rowKey,
        rowLink,
        gridTemplateColumns: columns
          .map((column) => {
            if (column.key === "name") {
              const width = 400 - (level || 1) * 24;
              return `minmax(${width}px, ${width}px)`;
            }
            return `minmax(${column.minWidth ? column.minWidth : "150px"}, ${
              column.maxWidth ? column.maxWidth : "1fr"
            })`;
          })
          .join(" "),
        selectedKeys,
        onChangeCheckbox,
      }}
    />
  );
}
